import * as AlterListMembershipActionMetadataKeys from 'automation-ui-action-features/actions/alter-list-membership/AlterListMembershipActionMetadataKeys';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ObjectListName from 'automation-ui-references/customer-data/ObjectListName';
import { jsx as _jsx } from "react/jsx-runtime";
const displayType = {
  ACTION_DETAIL: 'actionDetail',
  ACTION_PREVIEW: 'actionPreview'
};
const AlterListMembershipActionDetail = ({
  actionMetadata,
  messageLangPath = displayType.ACTION_DETAIL
}) => {
  const shouldAdd = actionMetadata.get(AlterListMembershipActionMetadataKeys.SHOULD_ADD);
  const listId = actionMetadata.get(AlterListMembershipActionMetadataKeys.LIST_ID);
  if (messageLangPath === displayType.ACTION_DETAIL) {
    return shouldAdd ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.alter-list-membership.action-detail.add",
      options: {
        listName: /*#__PURE__*/_jsx(ObjectListName, {
          id: listId
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.alter-list-membership.action-detail.remove",
      options: {
        listName: /*#__PURE__*/_jsx(ObjectListName, {
          id: listId
        })
      }
    });
  }
  return shouldAdd ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.alter-list-membership.action-preview.add",
    options: {
      listName: /*#__PURE__*/_jsx(ObjectListName, {
        id: listId
      })
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.alter-list-membership.action-preview.remove",
    options: {
      listName: /*#__PURE__*/_jsx(ObjectListName, {
        id: listId
      })
    }
  });
};
export default AlterListMembershipActionDetail;